import { HHTextField } from '@hinge-health/react-component-library';
import { Autocomplete } from '@mui/material';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { ClientType } from '../../types';

export interface ClientSelectProps {
  options: ClientType[];
  loading: boolean;
  disabled?: boolean;
  label?: string;
  error?: FieldError;
  onAfterChange?: () => void;
}

export const ClientSelect = ({
  options,
  loading,
  disabled = false,
  label = 'Client',
  error,
  onAfterChange,
}: ClientSelectProps): JSX.Element => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name="clientId"
      render={({ field: { onChange, value } }): JSX.Element => (
        <Autocomplete
          value={options.find(c => c.id === value) ?? null}
          options={options}
          getOptionLabel={(option): string => option.name}
          isOptionEqualToValue={(option, val): boolean => option.id === val?.id}
          onChange={(_, newValue): void => {
            onChange(newValue?.id ?? null);
            onAfterChange?.();
          }}
          disabled={disabled}
          loading={loading}
          renderInput={(params): JSX.Element => (
            <HHTextField
              {...params}
              hhVariant="variant-bypass"
              variant="outlined"
              label={label}
              error={!!error}
              helperText={error?.message}
              inputProps={{ ...params.inputProps, name: 'clientId' }}
              data-testid="form-client-input"
            />
          )}
        />
      )}
    />
  );
};
